<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>
 
    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <!-- <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">

                <li class="nav-item">

                    <a class="nav-link" href="../../index.html">
                        <img src="../../assets/navIcon/Dashboard.png" />&nbsp;&nbsp;
                        <span class="menu-title">Dashboard</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="mdi.html">
                        <img src="../../assets/navIcon/Audit.png" />&nbsp;&nbsp;
                        <span class="menu-title">Audit</span>
                        <i class="mdi mdi-contacts menu-icon"></i>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="../forms/basic_elements.html">
                        <img src="../../assets/navIcon/License.png" />&nbsp;&nbsp;
                        <span class="menu-title">licence</span>
                        <i class="mdi mdi-format-list-bulleted menu-icon"></i>
                    </a>
                </li>


                <li class="nav-item">
                    <a class="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false"
                        aria-controls="ui-basic">
                        <img src="../../assets/navIcon/Master.png" />&nbsp;&nbsp;
                        <span class="menu-title">Master</span>
                        <i class="menu-arrow"></i>
                        <i class="mdi mdi-crosshairs-gps menu-icon"></i>
                    </a>
                    <div class="collapse" id="ui-basic">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item"> <a class="nav-link" href="../ui-features/buttons.html">Prod</a></li>
                            <li class="nav-item"> <a class="nav-link">Notices</a></li>
                            <li class="nav-item"> <a class="nav-link">Ports</a></li>
                            <li class="nav-item"> <a class="nav-link">Country</a></li>
                            <li class="nav-item"> <a class="nav-link">Currency</a></li>
                        </ul>
                    </div>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/Portmaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Port</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/Chamaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CHA</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/countrymaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Terms & Conditions</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/currencymaster">
                        <img src="../../assets/navIcon/Copyrigths.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CopyRights</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/">
                        <img src="../../assets/navIcon/Logout.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">LogOut</span>

                    </a>
                </li>

            </ul>
        </nav> -->
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;" >
                <div class="page-header">
                    <h2 class="page-title text-primary">CHA</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Agent Code </label><span style="color: red;">*</span><br />
                            <input type="text" id="AgentCode" [(ngModel)]="AgentCode" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Company Name </label><span style="color: red;">*</span><br />
                            <input type="text" id="CompanyName" [(ngModel)]="CompanyName" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Branch </label><span style="color: red;">*</span><br />
                            <input type="text" id="Branch" [(ngModel)]="Branch" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Location </label><span style="color: red;">*</span><br />
                            <input type="text" id="Location" [(ngModel)]="Location" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Address 1 </label><br />
                            <input type="text" id="Address1" [(ngModel)]="Address1" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Address 2 </label><br />
                            <input type="text" id="Address2" [(ngModel)]="Address2" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <!-- <div class="col-lg-3" style="text-align: left;">
                            <label>Country</label><span style="color: red;">*</span><br />
                            <input type="text" id="Country" [(ngModel)]="Country" class="txt-input" />
                        </div> -->

                        <div class="col-lg-2" style="text-align: left;">
                            <label>Country</label><span style="color: red;">*</span><br />                           
                            <input type="text" id="Country" [(ngModel)]="Country" class="txt-input" list="contryname"/>                            
                            <datalist id="contryname">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnt of countrys" value={{cnt.countryname}}>{{cnt.countryname}}</option>
                            </datalist>
                        </div>

                        <div class="col-lg-3" style="text-align: left;">
                            <label>State</label><span style="color: red;">*</span><br />
                            <input type="text" id="State" [(ngModel)]="State" style="text-align: left;"
                                class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Postal Code</label><br />
                            <input type="text" id="Postal" [(ngModel)]="Postal" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Contact Name</label><br />
                            <input type="text" id="Contactname" [(ngModel)]="Contactname" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Designation</label><br />
                            <input type="text" id="Designation" [(ngModel)]="Designation" style="text-align: left;"
                                class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Contact Number</label><br />
                            <input type="text" id="Contactnum" [(ngModel)]="Contactnum" style="text-align: left;"
                                class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Email Id</label><br />
                            <input type="text" id="Email" [(ngModel)]="Email" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>CHA PAN Number</label><br />
                            <input type="text" id="Pannum" [(ngModel)]="Pannum" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>CHA Code</label><span style="color: red;">*</span><br />
                            <input type="text" id="Chacode" [(ngModel)]="Chacode" style="text-align: left;"
                                class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Description</label><br />
                            <input type="text" id="Description" [(ngModel)]="Description" style="text-align: left;"
                                class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom:20px;">
                        <div class="col-lg-4">
                            <label>Select</label><span style="color: red;">*</span><br />
                            <ng-multiselect-dropdown [placeholder]="'Select Type'" [settings]="dropdownSettings"
                                [data]="dropdownList" [(ngModel)]="select" id="select" (onSelect)="onItemSelect($event)"
                                (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)" >
                            </ng-multiselect-dropdown>                           
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-5"></div>
                        <div class="col-lg-3" style="padding-top: 39px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 30px;">
                            <button class="bttn-save" (click)="SubmitCha()" [hidden]="isShownSaveBtn">SAVE</button>
                            <button class="bttn-Update" (click)="UpdateCha()"
                                [hidden]="isShownUpdateBtn">Update</button> &nbsp;&nbsp;
                            <button class="bttn-clear" (click)="ClearCha()">Clear</button>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>
                </div>
            </div>

            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-6"></div>
                                                    <div class="col-lg-6" style="padding-right:0px;">
                                                        <div class="form-group" style="padding-left:65px;">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="agentcode">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Agent Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.agentcode}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="companyname">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Company Name</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.companyname}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="location">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Location</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.location}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="contactname">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Contact Name</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.contactname}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="contactnum">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Contact Number</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.contactnum}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCHA(element)" style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->


        </div>

    </div>
</div>